import { BoxV2 as Box } from 'portal-commons';
import { CSSProperties, FunctionComponent } from 'react';
import PhoneNumberInput, { Country } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

interface PhoneInputProps {
  style?: CSSProperties;
  error?: boolean;
  placeholder?: string;
  note?: string;
  value?: string;
  onCountryChange?: (value?: Country) => void;
  onChange?: (value?: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  [key: `data-${string}`]: unknown;
}

const PhoneInput: FunctionComponent<PhoneInputProps> = ({
  style,
  error,
  placeholder,
  note,
  value,
  onCountryChange,
  onChange,
  onBlur,
  onFocus,
  ...props
}) => (
  <Box
    className="registration campaign"
    style={style}
    data-testid={
      props['data-testid'] ? `PhoneInput-${props['data-testid']}` : undefined
    }
  >
    <PhoneNumberInput
      className={error ? 'error' : ''}
      limitMaxLength
      flags={flags}
      country="US"
      countryOptions={['US', 'IT', 'IN', '|']}
      placeholder={placeholder}
      value={value}
      onCountryChange={onCountryChange}
      onChange={(value) => onChange?.(value)}
      onFocus={() => onFocus?.()}
      onBlur={() => onBlur?.()}
    />
    {!!note && (
      <Box
        className="error-msg"
        sx={{
          color: '#B70505',
          fontSize: '10px',
          lineHeight: '12px',
          mt: '2px',
        }}
      >
        {note}
      </Box>
    )}
  </Box>
);

export default PhoneInput;
